<template>
    <modal-with-custom-content ref="modal"
                               :modalId="modalId"
                               :hideBottomCloseButton="true"
    >
        <slot>
            <div class="modal-save-search-wrapper" e2e-id="modal-save-search">
                <div class="modal-save-search-content">
                    <div class="modal-save-search-info">
                        <span class="modal-save-search-text-top">
                            <p>{{ translate.account.yourSearchSaved }}</p>
                        </span>

                        <default-loading-component v-if="loadingSave"></default-loading-component>
                        <span class="modal-save-search-text-middle" v-else>
                            <p class="modal-save-search-text-city">{{ selectedLocationText }}</p>
                            <p class="modal-save-search-text-filter">{{ selectedFiltersText }}</p>
                        </span>
                    </div>
                    <span class="btn btn-secondary cursor-pointer w-100 mt-2" @click="goToSavedSearchList">{{ translate.account.viewAllSavedSearches }}</span>
                </div>
            </div>
        </slot>
    </modal-with-custom-content>
</template>

<script>
import ModalWithCustomContentComponent from "@/components/partials/ModalWithCustomContentComponent";
import userMixin from "@/components/mixins/userMixin";
import savedSearchMixin from "@/components/mixins/search/savedSearchMixin";
import {regionRelativeUrl} from "@/core/utils/helpers/regions/regionUrlHelper";

const data = () => {
    return {
        store: $store,
        modalId: 'saveSearchModal',
        urlOfSavedSearches: '/users/account/alerts/',
    }
}

function saveSearch() {
    this.saveCurrentSearchResults();
    this.showModal();
}

function goToSavedSearchList() {
    if (typeof window !== "undefined") {
        window.location.href = regionRelativeUrl(this.urlOfSavedSearches);
    }
}

function showModal() {
    this.$refs.modal.showModal();
}

function closeModal() {
    this.$refs.modal.closeModal();
}

export default {
    data,
    computed: {
        ...mapState([
            'translate',
            'currentUser',
        ])
    },
    components: {
        'modal-with-custom-content': ModalWithCustomContentComponent,
    },
    watch: {
        currentUser() {
            this.phone = _.get(this, 'currentUser.phone');
        },
    },
    mixins: [
        userMixin,
        savedSearchMixin,
    ],
    methods: {
        showModal,
        closeModal,
        saveSearch,
        goToSavedSearchList,
    },
};
</script>
